export const WEBSITE = {
  FETCH: {
    REQUEST: Symbol('WEBSITE_FETCH_REQUEST'),
    SUCCESS: Symbol('WEBSITE_FETCH_SUCCESS'),
  },
};
export const SET_PLAYER_ANALYTICS_CONSENT = Symbol('SET_PLAYER_ANALYTICS_CONSENT');

/**
 * @param {*} website
 * @return {{type: *, payload: {website: {websiteModel}}}}
 */
export const websiteFetchSuccessAction = (website) => ({
  type: WEBSITE.FETCH.SUCCESS,
  payload: {
    website,
  },
});

export const setPlayerAnalyticsConsentAction = (gaveConsent) => ({
  type: SET_PLAYER_ANALYTICS_CONSENT,
  payload: { gaveConsent },
});
